import { render } from "./EditVideo.vue?vue&type=template&id=ca172522"
import script from "./EditVideo.vue?vue&type=script&lang=ts"
export * from "./EditVideo.vue?vue&type=script&lang=ts"
script.render = render

export default script